import icsBadge from 'assets/icons/ics-badge/ics-badge.svg';

export function IcsBadge(props: React.ImgHTMLAttributes<HTMLImageElement>) {
  return <img width={50} height={26} src={icsBadge} alt="ICS" {...props} />;
}
